var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencyfour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 14.7986C31 6.90426 24.2816 0.5 16 0.5C7.71842 0.5 1 6.90426 1 14.7986V19.201H31V14.7986Z",
    fill: "url(#paint0_linear_8056_37716)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 4.90246V0.5",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.70703 11.006V6.60352",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.293 11.006V6.60352",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.85742 6.15177V1.75684",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1426 6.15177V1.75684",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31 14.7986C31 6.90426 24.2816 0.5 16 0.5C7.71842 0.5 1 6.90426 1 14.7986V19.201H31V14.7986Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16 33.4995C24.2843 33.4995 31 27.0978 31 19.2009C31 11.304 24.2843 4.90234 16 4.90234C7.71573 4.90234 1 11.304 1 19.2009C1 27.0978 7.71573 33.4995 16 33.4995Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.5,
    d: "M15.9991 30.203C22.3737 30.203 27.5412 25.2771 27.5412 19.2006C27.5412 13.1242 22.3737 8.19824 15.9991 8.19824C9.62461 8.19824 4.45703 13.1242 4.45703 19.2006C4.45703 25.2771 9.62461 30.203 15.9991 30.203Z",
    fill: "#0F0F0F",
    stroke: "#878787",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.2,
    d: "M29.067 12.194L10.6644 32.5506C12.3223 33.1527 14.1144 33.4989 15.9933 33.4989C16.4986 33.4989 16.996 33.4763 17.4854 33.4236L30.9539 18.5155C30.8433 16.2202 30.1723 14.0754 29.0591 12.1864L29.067 12.194ZM20.1775 5.47363L2.38281 25.1605C3.21965 26.8989 4.41176 28.4417 5.87229 29.721L25.4275 8.08501C23.896 6.90349 22.1197 6.00795 20.1775 5.47363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M16 33.4995C24.2843 33.4995 31 27.0978 31 19.2009C31 11.304 24.2843 4.90234 16 4.90234C7.71573 4.90234 1 11.304 1 19.2009C1 27.0978 7.71573 33.4995 16 33.4995Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.7105 19.2013C22.7105 17.8994 22.2999 16.6877 21.5973 15.6793L23.6815 13.6926L21.8105 11.909L19.7341 13.8882C18.6684 13.2034 17.3815 12.8046 15.9999 12.8046C14.6184 12.8046 13.3631 13.1959 12.3052 13.8657L10.221 11.8789L8.34994 13.6625L10.4263 15.6417C9.70783 16.6576 9.28941 17.8843 9.28941 19.2013C9.28941 20.5183 9.69994 21.7148 10.4026 22.7233L8.31836 24.71L10.1894 26.4936L12.2657 24.5143C13.3315 25.1992 14.6184 25.598 15.9999 25.598C17.3815 25.598 18.6368 25.2067 19.6947 24.5369L21.7789 26.5237L23.6499 24.7401L21.5736 22.7609C22.292 21.7449 22.7105 20.5183 22.7105 19.2013ZM11.9341 19.2013C11.9341 17.064 13.7578 15.3256 15.9999 15.3256C18.242 15.3256 20.0657 17.064 20.0657 19.2013C20.0657 21.3386 18.242 23.077 15.9999 23.077C13.7578 23.077 11.9341 21.3386 11.9341 19.2013Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8056_37716",
    x1: 1,
    y1: 9.84676,
    x2: 31,
    y2: 9.84676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyfour);
export default __webpack_public_path__ + "static/media/currencyfour.80a69fbf44cc8382a0bfb21f5b8dc490.svg";
export { ForwardRef as ReactComponent };